



















































































































import { Component, Prop } from 'vue-property-decorator';
import { DepositAccountModule } from '@/store/Accounts/DepositAccountModule';
import { LendingAccountModule } from '@/store/Accounts/LendingAccountModule';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import ProductType from "@/models/Products/ProductType";
import FeeCreate from '@/components/Accounts/Shared/Fees/FeeCreate.vue';
import FeeState from '@/components/Accounts/Shared/Fees/FeeState.vue';
import Fee from '@/models/Accounts/Shared/Fees/Fee';

@Component({ name: 'Fees', components: { FeeCreate, FeeState } })
export default class extends SaascadaVue {

    @Prop({required: true})
    accountId: string;

    @Prop({required: true})
    currency: string;

    @Prop({required: true})
    productType: ProductType;

    headers = [
        { text: this.$t('pageText.depositAccounts.fields.amount'), width: "30%" },
        { text: this.$t('pageText.depositAccounts.fields.description'), width: "50%" },
        { text: this.$t('pageText.depositAccounts.fields.state'), width: "20%" },
    ];
    feesPage = 1;

    async beforeMount() {
        await this.getFees();
    }

    async getFees() {
        if (this.productType === ProductType.Deposit) {
            await DepositAccountModule.getFees();
        }
    }

    get fees() {
        if (this.productType === ProductType.Deposit) {
            return DepositAccountModule.fees;
        }
        else {
            return [];
        }
    }

    get totalFeesPages() {
        if (this.productType === ProductType.Deposit) {
            return DepositAccountModule.totalFeesPages;
        }
        else {
            return 1;
        }
    }

    get pageSize() {
        if (this.productType === ProductType.Deposit) {
            return DepositAccountModule.pageSize;
        }
        else {
            return LendingAccountModule.pageSize;
        }
    }

    get loading() {
        if (this.productType === ProductType.Deposit) {
            return DepositAccountModule.loadingFees;
        }
        else {
            return false;
        }
    }

    async updateCurrentFee(fee: Fee) {
        if (this.productType === ProductType.Deposit) {
            await DepositAccountModule.updateCurrentFee(fee);
        }
    }

    get currentFee() {
        if (this.productType === ProductType.Deposit) {
            return DepositAccountModule.currentFee;
        }
        else {
            return new Fee();
        }
    }

}
